import React from "react";

const PublicEventsIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5 3C16.1897 3 20 6.79907 20 11.5C20 16.2009 16.2009 20 11.5 20C6.79907 20 3 16.1897 3 11.5C3 8.56897 4.48806 5.97613 6.74271 4.45424"
        stroke="currentColor"
        stroke-width="0.97473"
        stroke-miterlimit="10"
      />
      <path
        d="M5.50233 5.4668C5.50233 5.4668 5.88562 7.78908 8.01625 8.47674C8.501 8.63457 8.63628 9.24332 8.27554 9.60407L6.61838 11.25C6.61838 11.25 6.52819 12.6704 5.19795 12.614C5.19795 12.614 3.81135 9.96481 3.21387 9.57025"
        stroke="currentColor"
        stroke-width="0.97473"
        stroke-miterlimit="10"
      />
      <path
        d="M7.32948 18.7915C7.32948 18.7915 7.09274 16.0183 7.69022 15.6238C7.98332 15.4321 7.93823 14.891 7.81422 14.395C7.70149 13.944 8.12987 13.5495 8.56953 13.6735C9.6743 14.0004 11.2638 14.6204 11.6246 15.6125L9.80958 16.7736L9.44884 19.7385"
        stroke="currentColor"
        stroke-width="0.97473"
        stroke-miterlimit="10"
      />
      <path
        d="M17.8812 5.88672L14.0934 7.52133L13.1916 8.45701C13.1916 8.45701 13.0563 10.52 12.4926 11.7601C12.2108 12.3688 12.4137 13.0903 12.9661 13.4736L13.2479 13.6765L14.8149 17.4418L16.427 15.514L16.0324 14.1838L17.1034 11.2979L20.0006 11.5121"
        stroke="currentColor"
        stroke-width="0.97473"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default PublicEventsIcon;
